"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
var immutability_helper_1 = require("immutability-helper");
var action_1 = require("../../action");
var EmitAction_1 = require("../../action/EmitAction");
/**
 * Fluent builder for {Result}s
 */
var ResultBuilder = /** @class */ (function () {
    function ResultBuilder() {
        /**
         * @hidden
         *
         * @type {any[]}
         * @private
         */
        this._actions = [];
        /**
         * @hidden
         * @type {any[]}
         * @private
         */
        this._updates = [];
    }
    /**
     * Adds the given actions to the result
     *
     * @param actions {ActionList} the actions
     * @return {this} for chaining
     */
    ResultBuilder.prototype.action = function () {
        var actions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            actions[_i] = arguments[_i];
        }
        var _a;
        (_a = this._actions).push.apply(_a, actions);
        return this;
    };
    /**
     * Cancel an existing event timeout timer
     * @return {ResultBuilder}
     */
    ResultBuilder.prototype.cancelEventTimeout = function () {
        return this.action(new action_1.EventTimeoutAction(-1));
    };
    /**
     * Cancel an existing state timeout timer
     * @return {ResultBuilder}
     */
    ResultBuilder.prototype.cancelStateTimeout = function () {
        return this.action(new action_1.StateTimeoutAction(-1));
    };
    /**
     * Cancel the named generic timer, if active
     * @param name
     * @return {ResultBuilder}
     */
    ResultBuilder.prototype.cancelTimeout = function (name) {
        return this.action(new action_1.GenericTimeoutAction(-1, name));
    };
    /**
     * Set data mutation specs
     * @param spec
     * @return {this<TData>}
     */
    ResultBuilder.prototype.data = function (spec) {
        this._updates.push(spec);
        return this;
    };
    /**
     * Tells the state machine to emit the given event with arguments
     * @param name
     * @param args
     * @return {ResultBuilder}
     */
    ResultBuilder.prototype.emit = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return this.action(new (EmitAction_1.default.bind.apply(EmitAction_1.default, [void 0, name].concat(args)))());
    };
    /**
     *
     * @param time
     * @return {ResultBuilder}
     */
    ResultBuilder.prototype.eventTimeout = function (time) {
        return this.action(new action_1.EventTimeoutAction(time));
    };
    /**
     * Adds an event of type 'internal'
     * @param context
     * @return {ResultBuilder}
     * @param extra
     */
    ResultBuilder.prototype.internalEvent = function (context, extra) {
        return this.action(new action_1.NextEventAction("internal", context, extra));
    };
    /**
     * Adds a next-event action
     *
     * @param type the next event's type
     * @param context optional event context
     * @return {ResultBuilder}
     * @param extra
     */
    ResultBuilder.prototype.nextEvent = function (type, context, extra) {
        return this.action(new action_1.NextEventAction(type, context, extra));
    };
    /**
     * Adds a postpone action
     *
     * @return {ResultBuilder}
     */
    ResultBuilder.prototype.postpone = function () {
        return this.action(new action_1.PostponeAction());
    };
    /**
     * Adds a {Reply} action
     *
     * @param from - sends the reply here
     * @param msg - the message to send
     * @return {ResultBuilder}
     */
    ResultBuilder.prototype.reply = function (from, msg) {
        return this.action(new action_1.ReplyAction(from, msg));
    };
    /**
     *
     * @param time
     * @return {ResultBuilder}
     */
    ResultBuilder.prototype.stateTimeout = function (time) {
        return this.action(new action_1.StateTimeoutAction(time));
    };
    /**
     * Adds a {GenericTimeout} action with the given timeout
     * and optional name
     * @param time - the timeout in ms
     * @param name - optional name
     * @return {ResultBuilder} this
     */
    ResultBuilder.prototype.timeout = function (time, name) {
        return this.action(new action_1.GenericTimeoutAction(time, name));
    };
    /**
     * @hidden
     * Apply updates to the given data
     * @param data
     * @return {TData}
     */
    ResultBuilder.prototype.applyUpdates = function (data) {
        for (var _i = 0, _a = this._updates; _i < _a.length; _i++) {
            var u = _a[_i];
            data = immutability_helper_1.default(data, u);
        }
        return data;
    };
    return ResultBuilder;
}());
exports.default = ResultBuilder;
//# sourceMappingURL=ResultBuilder.js.map